import { supabase } from './supabase';
import { handleError } from './errors';

const ORG_ID = '00000000-0000-0000-0000-000000000001';

export interface Module {
  id: string;
  name: string;
  enabled: boolean;
}

export const DEFAULT_MODULES: Module[] = [
  { id: 'dashboard', name: 'Dashboard', enabled: true },
  { id: 'properties', name: 'Properties', enabled: true },
  { id: 'budget', name: 'Budget', enabled: true },
  { id: 'tenants', name: 'Tenants', enabled: true },
  { id: 'contracts', name: 'Contracts', enabled: true },
  { id: 'marketing', name: 'Marketing', enabled: true },
  { id: 'payments', name: 'Payments', enabled: true },
  { id: 'documents', name: 'Documents', enabled: true },
  { id: 'reports', name: 'Reports', enabled: true },
  { id: 'notifications', name: 'Notifications', enabled: true },
  { id: 'maintenance', name: 'Maintenance', enabled: true },
  { id: 'integrations', name: 'Integrations', enabled: true },
  { id: 'settings', name: 'Settings', enabled: true },
  { id: 'financial_import', name: 'Financial Import', enabled: true },
];

export async function getModuleSettings(): Promise<Module[]> {
  const { data: settings, error } = await supabase
    .from('system_settings')
    .select()
    .eq('category', 'modules') 
    .eq('key', 'enabled_modules')
    .eq('organization_id', ORG_ID);

  if (error) {
    handleError(error, { 
      action: 'getModuleSettings',
      context: { organizationId: ORG_ID }
    });
    return DEFAULT_MODULES;
  }

  if (!settings?.length) {
    return DEFAULT_MODULES;
  }

  try {
    const modules = settings[0].value as Module[];
    return Array.isArray(modules) ? modules : DEFAULT_MODULES;
  } catch (err) {
    handleError(err, {
      action: 'getModuleSettings',
      context: { organizationId: ORG_ID }
    });
    return DEFAULT_MODULES;
  }
}

export async function updateModuleSettings(modules: Module[]): Promise<void> {
  const { error } = await supabase
    .from('system_settings')
    .upsert({
      organization_id: ORG_ID,
      category: 'modules',
      key: 'enabled_modules',
      value: modules
    }, {
      onConflict: 'organization_id,category,key'
    });

  if (error) {
    handleError(error, {
      action: 'updateModuleSettings',
      context: { organizationId: ORG_ID, moduleCount: modules.length }
    });
    throw new Error('Failed to update module settings');
  }
}